// Local storage keys
export const LANG_KEY = "language";

export const MENTIONS_ALL_ID = "mention-all";
export const TASK_ORDER_EMAIL_ID = "task_order_email";
export const TASK_ORDER_PHONE_ID = "task_order_phone";
export const TASK_ORDER_CUSTOMER_NAME = "customer_name";

// Consts
export const CHAT_GROUP_MAX_SIZE = 250;

// URL's
export const TERMS_OF_USE_URL = "https://jugl.com/terms-of-service";
export const PRIVACY_POLICY_URL = "https://jugl.com/privacy-policy";
export const HELP_CENTER_URL = "https://help.jugl.com";
export const HELP_CENTER_SORTING_URL =
  "https://help.jugl.com/en/articles/12176746-sort-smartly-across-jugl-how-to-use-the-sorting-feature-for-faster-task-management";

export const DEFAULT_AUDIO_WAVEFORM_LENGTH = 70;

export const DEFAULT_ENTITY_CURRENCY = "USD";

export const ARIVU_SYSTEM_CHAT_USER_ID = "00000000-0000-0000-0000-000000000000";

export const FORM_EXTERNAL_USER_ID = "00000000-0000-0000-0000-000000000000";
export const CHAT_MESSAGE_PAYLOAD_VERSION = 2;

export const PROD_JUGL_ENTITY_ID = "07aa1fe3-d865-474d-883a-9d37530e1bc3";
